'use client';

import { useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { IconChevronDown, IconMap, IconPlus } from '@tabler/icons-react';
import { Box, Button, Group, Modal, Text, ThemeIcon } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useAddressStore } from '@/src/modules/auth/stores/use-address-store';
import { CartAddress } from '../../cart/CartAddress';

export function AddressInput() {
  const [opened, { open, close }] = useDisclosure(false);
  const selectedAddress = useAddressStore((s) => s.selectedAddress);
  const storeAddressListRaw = useAddressStore((s) => s.address);

  const addressList = useMemo(
    () => storeAddressListRaw.filter((a) => a.is_active),
    [storeAddressListRaw]
  );
  const hasAddress = addressList.length > 0;
  const router = useRouter();
  return (
    <Group gap="xs">
      <ThemeIcon variant="white">
        <IconMap style={{ width: '70%', height: '70%' }} />
      </ThemeIcon>
      <Text fw={600}>Kirim ke</Text>
      {hasAddress ? (
        <>
          <Button
            size="xs"
            variant="outline"
            radius="sm"
            rightSection={<IconChevronDown size={14} />}
            onClick={open}
          >
            {selectedAddress?.place}
          </Button>
          <Modal opened={opened} onClose={close} title="Ubah Alamat" centered>
            <Box py={4}>
              <CartAddress withBorder={false} onAddAddress={close} />
            </Box>
          </Modal>
        </>
      ) : (
        <Button
          size="xs"
          variant="outline"
          leftSection={<IconPlus size={14} />}
          onClick={() => {
            close();
            router.push(`/address`);
          }}
        >
          Tambah Alamat
        </Button>
      )}
    </Group>
  );
}
